<template>
  <!-- 客户服务 -->
  <div class="big service">
    <div class="page_title">歧黄助理</div>
    <div style="padding: 20px">
      <div class="container flex between">
        <div class="left bb">
          <div class="top flex bb">
            <el-input
              v-model="doctor_name"
              placeholder="医生名字"
              size="small"
              clearable
              @keyup.enter.native="searchDoctor"
              @input="clearDoctor"
            />
            <el-button
              type="primary"
              size="small"
              @click="searchDoctor"
            >查询</el-button>
          </div>
          <template v-if="!searchShow">
            <!-- 对话列表 -->
            <div class="count">医生数：({{ this.doctorList.length }})</div>
            <div class="doctor_list">
              <div
                class="flex between box"
                v-for="item in doctorList"
                :key="item.doc_con_username"
                @click="selectDoctor(item)"
                :class="item.current ? 'current' : ''"
                v-show="item.doc_con_username"
              >
                <div class="d1">{{ item.doctor_name }}</div>
                <div class="d2">
                  {{ item.update_time || '' }}
                  <span :class="item.active ? '' : 'opacity'">●</span>
                </div>
              </div>
            </div>
          </template>
          <template v-if="searchShow">
            <!-- 搜索列表 -->
            <div
              class="doctor_list"
              style="margin-top: 5px"
            >
              <div
                class="flex between box"
                v-for="item in searchList"
                :key="item.doc_con_username"
                @click="selectDoctor(item, 2)"
              >
                <div class="d1">{{ item.doctor_name }}</div>
                <div class="d2">
                  {{ item.update_time == 0 ? '' : item.update_time }}
                </div>
              </div>
            </div>
            <div v-show="searchList.length == 0">暂无匹配的医生！</div>
          </template>
        </div>
        <div class="right bb">
          <template v-if="doctorInfo.doc_con_username">
            <div class="top flex align-center">
              <span>{{ doctorInfo.doctor_name }}</span>
              <span>{{ doctorInfo.age }}</span>
              <span>{{ doctorInfo.title }}</span>
              <span>{{ doctorInfo.department_name }}</span>
              <span>{{ doctorInfo.hospital }}</span>
            </div>
            <div
              class="dialogBox"
              ref="dialogBox"
              v-loading="loading"
            >
              <div
                v-for="(item, index) in dialogueData"
                :key="item.doc_con_username"
              >
                <p
                  class="time"
                  v-if="
                    index == 0 ||
                    (index > 0 &&
                      item.time - dialogueData[index - 1].time > 1000 * 60)
                  "
                >
                  {{ formatDate(item.time) }}
                </p>
                <!-- 自己发送的文本消息 -->
                <div
                  class="patient-dialogue flex"
                  v-if="item.showType == 1"
                >
                  <img
                    src="@/assets/img/kefu.svg"
                    alt
                    class="patient-img"
                  />
                  <div class="text">{{ item.data }}</div>
                </div>
                <!-- 医生发送的文本消息 -->
                <div
                  class="doctor-dialogue flex"
                  v-if="item.showType == 2"
                >
                  <img
                    :src="doctorInfo.doc_img ? doctorInfo.doc_img : doc_img"
                    alt
                    class="patient-img"
                  />
                  <div class="text">{{ item.data }}</div>
                </div>
                <!-- 医生发送的图片消息 -->
                <div
                  class="doctor-dialogue flex"
                  v-if="item.showType == 4"
                >
                  <img
                    :src="doctorInfo.doc_img ? doctorInfo.doc_img : doc_img"
                    alt
                    class="doctor-img"
                  />
                  <el-image
                    :src="item.url"
                    :preview-src-list="[item.url]"
                    class="my-img"
                  ></el-image>
                </div>
                <!-- 自己发送的图片消息 -->
                <div
                  class="patient-dialogue flex"
                  v-if="item.showType == 3"
                >
                  <img
                    src="@/assets/img/kefu.svg"
                    alt
                    class="patient-img"
                  />
                  <el-image
                    :src="item.url"
                    :preview-src-list="[item.url]"
                    class="my-img"
                  ></el-image>
                </div>
                <!-- 医生发送的语音 -->
                <div
                  class="doctor-dialogue flex"
                  v-if="item.showType == 6"
                  @click="playAudio(item, index)"
                >
                  <img
                    :src="doctorInfo.doc_img ? doctorInfo.doc_img : doc_img"
                    alt
                    class="doctor-img"
                  />
                  <div
                    class="text flex between align-center"
                    style="width: 2rem"
                  >
                    <img
                      src="@/assets/img/music.png"
                      alt
                      style="width: 20px"
                      v-show="!item.playing"
                    />

                    <img
                      src="@/assets/img/play.gif"
                      alt
                      style="20px"
                      v-show="item.playing"
                    />

                    <span v-show="item.duration != 0">{{ item.duration }}"</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="bottom bb flex column">
              <div>
                <el-upload
                  class="avatar-uploader"
                  action="up"
                  :show-file-list="false"
                  :before-upload="beforeAvatarUpload"
                  :http-request="sendImg"
                  accept=".png,.jpeg,.jpg,.bmp"
                >
                  <img
                    src="@/assets/img/img.svg"
                    alt
                  />
                </el-upload>
              </div>
              <el-input
                type="textarea"
                :rows="4"
                placeholder="请输入内容"
                v-model="textarea"
                class="resizeNone"
                @keyup.enter.native="sendText"
              ></el-input>
              <el-button
                type="primary"
                size="small"
                style="width: 70px; margin-left: auto; margin-right: 80px"
                @click="sendText"
                :disabled="!textarea && loading"
              >发送</el-button>
            </div>
          </template>
          <!-- 播放器     -->
          <audio ref="audio">
            <source :src="musicUrl" />
          </audio>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import commonUtil from '../../../service/utils/commonUtil';
import storageUtil from '../../../service/utils/storage';
import WebIM from '@/service/utils/WebIM';
export default {
  name: 'service',
  data() {
    return {
      doctor_name: '',
      user_id: 'doctor_customer_service_001',
      doc_img: require('@/assets/img/yisheng.svg'),
      doctorList: [],
      searchList: [], //查询的医生信息
      searchShow: false, //搜索列表
      doctorInfo: {},
      textarea: '',
      dialogueData: [], //对象中的showType值 0是系统消息 1是自己发送的文本消息。2是医生发送的文本消息 3是自己发送的图片消息。4是医生发送的图片消息
      musicUrl: '',
      loading: false
    };
  },
  computed: {
    latestMsg() {
      return this.$store.state.service.latestMsg; //最后一条收到的消息
    },
    historyList() {
      return this.$store.state.service.historyList; //保存的历史记录
    },
    error() {
      return this.$store.state.service.error; //保存的历史记录
    }
  },
  watch: {
    latestMsg(newValue, oldValue) {
      newValue = JSON.parse(JSON.stringify(newValue));
      let doc_con_username = newValue.from; //接收到的消息的医生账号
      if (doc_con_username == this.doctorInfo.doc_con_username) {
        if (newValue.contentsType == 'TEXT' && newValue.type == 'chat') {
          //收到普通文本
          newValue.showType = newValue.from == this.user_id ? 1 : 2;
          this.dialogueData.push(newValue);
        } else if (
          newValue.contentsType == 'IMAGE' &&
          newValue.type == 'chat' //图片消息
        ) {
          newValue.showType = newValue.from == this.user_id ? 3 : 4;
          this.dialogueData.push(newValue);
        } else if (newValue.contentsType == 'VOICE') {
          //语音消息
          newValue.showType = 6;
          newValue.isSet = true;
          this.$set(newValue, 'playing', false);
          this.dialogueData.push(newValue);
        }
        this.$nextTick(() => {
          let element = this.$refs.dialogBox;
          element.scrollTop = element.scrollHeight;
        });
      } else {
        //判断是否是新医生发来的信息 是的话需要添加进列表,如果列表里面没有 就查询列表并插入
        let index = this.doctorList.findIndex((ele) => {
          //判断该消息属于列表的哪一条
          return ele.doc_con_username == doc_con_username;
        });
        if (index != -1) {
          let doctorInfo = JSON.parse(JSON.stringify(this.doctorList[index]));
          doctorInfo.active = true;
          this.doctorList.splice(index, 1);
          this.doctorList.unshift(doctorInfo);
        } else {
          //查询医生信息并且新加入到列表中
          this.getDoctorInfoByConUserName(doc_con_username);
        }
      }
    },
    error(newValue, oldValue) {
      this.$confirm('已有其他人登录环信，是否重新登录?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false
      })
        .then(() => {
          window.location.reload();
        })
        .catch(() => {});
    }
  },
  beforeRouteEnter(to, from, next) {
    next();
    if (from.name == 'consult') {
      location.reload();
    }
  },
  mounted() {
    this.getDoctorList().then(() => {
      this.loginIM();
    });
  },
  methods: {
    getDoctorList() {
      return new Promise((resolve, reject) => {
        this.axios
          .post('platform/assistant/getDoctorList')
          .then((res) => {
            let list = res.data.list;
            list.forEach((ele) => {
              if (ele.update_time) {
                ele.update_time = commonUtil.formatTime(ele.update_time);
              }
              ele.current = false;
              let count = sessionStorage.getItem(
                'group' + ele.doc_con_username
              );
              ele.active = count && count > 0 ? true : false;
            });
            this.doctorList = list;
            resolve();
          })
          .catch((err) => {
            console.log(err);
            reject();
          });
      });
    },
    loginIM() {
      return new Promise((resolve, reject) => {
        if (WebIM.conn.isOpened(true)) {
          // console.log('环信已经登陆')
          resolve();
        } else {
          let options = {
            user: this.user_id,
            pwd: this.user_id,
            appKey: WebIM.config.appkey,
            apiUrl: WebIM.config.apiURL,
            success: (res) => {
              console.log('客服登录成功');
              resolve(res);
            },
            error: (err) => {
              console.log('环信登录失败');
              reject(err);
            }
          };
          window.WebIM.conn.open(options);
        }
      });
    },
    //input为空时 清除搜索列表
    clearDoctor(e) {
      if (!e) {
        this.searchShow = false;
      }
    },
    //选择医生
    selectDoctor(item, type = 1) {
      this.searchShow = false;
      item.active = false;
      sessionStorage.removeItem('group' + item.doc_con_username);
      this.doctorList.forEach((ele) => {
        ele.current = ele.id == item.id ? true : false;
      });
      this.doctorInfo = item;
      this.getHistory();
      if (type == 2) {
        //从搜索列表里过来的 需要判断是否在会话列表里面 不在的话就要补上

        let index = this.doctorList.findIndex((ele) => {
          //判断该消息属于列表的哪一条
          return ele.doc_con_username == item.doc_con_username;
        });
        if (index != -1) {
          let doctorInfo = JSON.parse(JSON.stringify(this.doctorList[index]));
          doctorInfo.active = true;
          this.doctorList.splice(index, 1);
          this.doctorList.unshift(doctorInfo);
        } else {
          //加入到列表中
          item.id = 0;
          console.log(item);
          this.doctorList.unshift(item);
        }
      }
    },
    //发送文字
    sendText() {
      if (!this.textarea) return;
      this.textarea = this.textarea.replace(/(\r|\n)/gi, '');
      this.loading = true;
      let id = window.WebIM.conn.getUniqueId(); // 生成本地消息id
      let msg = new window.WebIM.message('txt', id); // 创建文本消息
      let option = {
        msg: this.textarea, // 消息内容
        to: this.doctorInfo.doc_con_username,
        roomType: false, // 群聊类型，true时为聊天室，false时为群组
        ext: {}, // 扩展消息
        success: (res) => {
          let obj = {
            time: new Date().getTime(),
            data: this.textarea,
            showType: 1, //自己发送的文本消息
            to: this.doctorInfo.doc_con_username,
            contentsType: 'TEXT',
            type: 'chat',
            from: this.user_id,
            ext: {}
          };
          this.$store.commit('service/addNewMsg', { msg: obj });
          this.dialogueData.push(obj);
          this.sendCustomerService();
          let info = this.doctorList.find((ele) => {
            //判断该消息属于列表的哪一条
            return ele.doc_con_username == this.doctorInfo.doc_con_username;
          });
          info.update_time = commonUtil.formatTime(new Date().getTime());
          this.$nextTick(() => {
            this.textarea = '';
            let element = this.$refs.dialogBox;
            element.scrollTop = element.scrollHeight;
            this.loading = false;
          });
        },
        fail: function () {
          this.loading = false;
          console.log('failed');
        }
      };

      msg.set(option);
      WebIM.conn.send(msg.body);
    },
    //检查图片
    beforeAvatarUpload(file) {
      if (
        file.type !== 'image/jpeg' &&
        file.type !== 'image/png' &&
        file.type !== 'image/jpg' &&
        file.type !== 'image/bmp'
      ) {
        this.$message.error('文件格式不正确');
        return false;
      }
      if (file.size > 1024 * 1024 * 10) {
        this.$message.error('文件格式不正确');
        return false;
      }
    },
    //发送图片
    sendImg(e) {
      let url = URL.createObjectURL(e.file);
      let id = WebIM.conn.getUniqueId();
      let msg = new WebIM.message('img', id);
      //拼接环信需要的file
      let file = {
        data: e.file,
        filename: e.file.name,
        filetype: e.file.type,
        url: url
      };
      let option = {
        apiUrl: WebIM.config.apiURL,
        file: file,
        to: this.doctorInfo.doc_con_username, // 接收消息对象
        roomType: false,
        onFileUploadError: (err) => {
          // 消息上传失败
          this.$message.error('图片上传失败' + err);
        },
        onFileUploadComplete: (res) => {
          // 图片上传成功
          let url = res.uri + '/' + res.entities[0].uuid;
          let obj = {
            time: res.timestamp,
            url: url,
            showType: 3, //自己发的图片消息
            to: this.doctorInfo.doc_con_username,
            contentsType: 'IMAGE',
            type: 'chat',
            from: this.user_id
          };
          this.dialogueData.push(obj);
          this.$store.commit('service/addNewMsg', { msg: obj });
          this.sendCustomerService();
          let info = this.doctorList.find((ele) => {
            //判断该消息属于列表的哪一条
            return ele.doc_con_username == this.doctorInfo.doc_con_username;
          });
          info.update_time = commonUtil.formatTime(res.timestamp);
          this.$nextTick(() => {
            let element = this.$refs.dialogBox;
            element.scrollTop = element.scrollHeight;
          });
        }
      };
      msg.set(option);
      WebIM.conn.send(msg.body);
    },
    formatDate(time) {
      return commonUtil.formatTime(time);
    },
    //获取历史记录
    getHistory() {
      this.dialogueData = [];
      this.loading = true;
      let list = this.historyList.find((ele) => {
        return ele.doc_con_username == this.doctorInfo.doc_con_username;
      });
      //如果vuex里面有 直接用vuex里的记录 否则去获取新的
      if (list) {
        if (list.msgs.length == 0) {
          this.loading = false;
          return false;
        }
        let msgs = JSON.parse(JSON.stringify(list.msgs));
        this.filterHistory(msgs);
      } else {
        let options = {
          queue: this.doctorInfo.doc_con_username,
          isGroup: false,
          count: 1000,
          success: (msgs) => {
            //将获得的历史记录放入vuex
            let newMsgs = JSON.parse(JSON.stringify(msgs));
            this.$store.commit('service/setHistoryList', {
              msgs: newMsgs,
              doc_con_username: this.doctorInfo.doc_con_username
            });
            if (msgs.length == 0) {
              this.loading = false;
              return false;
            }
            this.filterHistory(msgs);
          },
          fail: (err) => {
            console.log('历史记录调用失败');
            console.log(err);
            this.loading = false;
          }
        };
        WebIM.conn.fetchHistoryMessages(options);
      }
    },
    //处理历史记录
    filterHistory(msgs) {
      msgs.forEach((newValue) => {
        if (newValue.contentsType == 'TEXT' && newValue.type == 'chat') {
          //收到普通文本
          newValue.showType = newValue.from == this.user_id ? 1 : 2;
          this.dialogueData.push(newValue);
        } else if (
          newValue.contentsType == 'IMAGE' &&
          newValue.type == 'chat' //图片消息
        ) {
          newValue.showType = newValue.from == this.user_id ? 3 : 4;
          this.dialogueData.push(newValue);
        } else if (newValue.contentsType == 'VOICE') {
          //语音消息
          newValue.showType = 6;
          newValue.duration = newValue.length;
          this.$set(newValue, 'playing', false);
          this.dialogueData.push(newValue);
          this.setAudioHistory(newValue);
        }
      });
      this.$nextTick(() => {
        let element = this.$refs.dialogBox;
        element.scrollTop = element.scrollHeight;
        this.loading = false;
      });
    },

    setAudioHistory(item) {
      if (item.isSet) {
        return;
      }
      let index = this.dialogueData.findIndex((ele) => {
        return ele.id == item.id;
      });
      let options = {
        url: item.url,
        headers: {
          Accept: 'audio/mp3'
        },
        onFileDownloadComplete: (response) => {
          let objectUrl = WebIM.utils.parseDownloadResponse.call(
            WebIM.conn,
            response
          );
          this.$set(this.dialogueData[index], 'url', objectUrl);
        },
        onFileDownloadError: function () {
          console.log('音频历史记录保存失败');
        }
      };
      WebIM.utils.download.call(WebIM.conn, options);
    },
    //查询医生信息并且新加入到列表中
    getDoctorInfoByConUserName(doc_con_username) {
      let data = {
        doc_con_username
      };
      this.axios
        .post('platform/assistant/getDoctorInfoByConUserName', data)
        .then((res) => {
          let info = res.data.info;
          info.update_time = commonUtil.formatTime(info.update_time);
          info.active = true;
          info.current = false;
          this.doctorList.unshift(info);
        });
    },
    //播放音乐
    playAudio(item, index) {
      this.dialogueData.forEach((ele) => {
        ele.playing = false;
      });
      this.$set(this.dialogueData[index], 'playing', true);
      let audio = this.$refs.audio;
      audio.src = item.url;
      if (audio.paused) {
        // 开始播放当前点击的音频
        audio.load();
        audio.oncanplay = () => {
          audio.play();
        };
      } else {
        audio.pause();
        item.play = false;
      }
      audio.onended = () => {
        this.$set(this.dialogueData[index], 'playing', false);
      };
      audio.onerror = () => {
        console.log('onerror: ' + audio.error.code);
        console.log(audio.src);
      };
    },
    //告知后端已发送消息
    sendCustomerService() {
      let data = {
        id: this.doctorInfo.id || 0,
        doctor_id: this.doctorInfo.doctor_id
      };
      this.axios.post('platform/assistant/sendCustomerService', data);
    },
    searchDoctor() {
      if (!this.doctor_name) {
        this.$message.error('请输入医生名字！');
        return false;
      }
      let data = {
        doctor_name: this.doctor_name
      };
      this.axios
        .post('platform/assistant/searchDoctor', data)
        .then((res) => {
          let list = res.data.list;
          list.forEach((ele) => {
            if (ele.update_time) {
              ele.update_time = commonUtil.formatTime(ele.update_time);
            }
            let count = sessionStorage.getItem('group' + ele.doc_con_username);
            ele.active = count && count > 0 ? true : false;
          });
          this.searchList = list;
          this.searchShow = true;
        })
        .catch((err) => {
          console.log(err);
        });
    }
  },
  beforeRouteLeave(to, from, next) {
    window.WebIM.conn.close();
    next();
  }
};
</script>

<style lang='scss' scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  height: calc(100vh - 140px);
  .left {
    width: 240px;
    height: calc(100vh - 140px);
    padding: 10px;
    overflow: hidden;
    border-right: solid 1px #e9e9e9;
    .top {
      button {
        margin-left: 10px;
      }
    }
    .count {
      text-align: left;
      font-weight: bold;
      margin: 5px 0;
    }
    .doctor_list {
      overflow: auto;
      height: 100%;
      .box {
        line-height: 42px;
        cursor: pointer;
        box-sizing: border-box;
        padding: 0 5px;
        &.current,
        &:hover {
          background-color: #a3c2a0;
          .d1,
          .d2 {
            color: #ffffff;
          }
        }
        .d1 {
          color: #666666;
        }
        .d2 {
          color: #c9c9c9;
          span {
            color: #f24e33;
            opacity: 1;
            &.opacity {
              opacity: 0;
            }
          }
        }
      }
    }
  }
  .right {
    position: relative;
    flex: 1;
    height: calc(100vh - 140px);
    box-sizing: border-box;
    padding: 20px 0;
    .top {
      width: 100%;
      background-color: #a3c2a0;
      color: #ffffff;
      line-height: 50px;
      box-sizing: border-box;
      padding: 0 10px;
      span {
        margin: 0 30px;
      }
    }
    .dialogBox {
      overflow: auto;
      height: calc(100vh - 390px);
      box-sizing: border-box;
      padding: 15px;
      &::-webkit-scrollbar {
        display: none;
      }
      .time {
        margin-top: 15px;
        text-align: center;
        font-size: 12px;
        color: #9b9b9b;
        line-height: 25px;
      }
      .time + .doctor-dialogue,
      .time + .patient-dialogue {
        margin-top: 0;
      }
      .doctor-dialogue {
        margin: 15px 0;
        position: relative;

        .text {
          margin-left: 15px;
          max-width: 600px;
          padding: 14px;
          background-color: #ffffff;
          box-shadow: 0px 2px 15px 0px #e6e6e6;
          border-radius: 10px;
          line-height: 25px;
          color: #666666;
        }

        .my-img {
          height: 150px;
          max-width: 500px;
          margin: 0 10px;
        }
      }

      .patient-dialogue {
        margin: 15px 0;
        position: relative;
        flex-direction: row-reverse;

        .text {
          margin-right: 15px;
          max-width: 600px;
          padding: 14px;
          background-color: #a3c2a0;
          box-shadow: 0px 2px 15px 0px #e6e6e6;
          border-radius: 10px;
          line-height: 25px;
          color: #ffffff;
        }
      }

      .patient-img {
        width: 50px;
        height: 50px;
        border-radius: 100%;
      }

      .doctor-img {
        width: 50px;
        height: 50px;
        border-radius: 100%;
      }
    }
    .bottom {
      position: absolute;
      width: 100%;
      padding: 10px;
      left: 0;
      bottom: 0;
      height: 180px;
      text-align: left;
      border-top: solid 1px #e9e9e9;
      background-color: #ffffff;
      img {
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang='scss'>
.service {
  .resizeNone {
    textarea {
      border: none;
      padding: 5px 0;
    }
    .el-textarea__inner {
      //el_input中的隐藏属性
      resize: none; //主要是这个样式
    }
  }
  .my-img {
    & > img {
      height: 150px;
      max-width: 500px;
      margin: 0 10px;
    }
  }
}
</style>